/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthDocsRouteImport } from './routes/_auth.docs'
import { Route as AuthDocsDocumentIdIndexRouteImport } from './routes/_auth.docs_.$documentId.index'
import { Route as AuthDocsDocumentIdChar123StepChar125RouteImport } from './routes/_auth.docs_.$documentId.{-$step}'
import { Route as AuthDocsDocumentIdSuccessRouteImport } from './routes/_auth.docs_.$documentId.success'
import { Route as AuthDocsDocumentIdReviewRouteImport } from './routes/_auth.docs_.$documentId.review'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDocsRoute = AuthDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocsDocumentIdIndexRoute = AuthDocsDocumentIdIndexRouteImport.update({
  id: '/docs_/$documentId/',
  path: '/docs/$documentId/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocsDocumentIdChar123StepChar125Route =
  AuthDocsDocumentIdChar123StepChar125RouteImport.update({
    id: '/docs_/$documentId/{-$step}',
    path: '/docs/$documentId/{-$step}',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDocsDocumentIdSuccessRoute =
  AuthDocsDocumentIdSuccessRouteImport.update({
    id: '/docs_/$documentId/success',
    path: '/docs/$documentId/success',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDocsDocumentIdReviewRoute =
  AuthDocsDocumentIdReviewRouteImport.update({
    id: '/docs_/$documentId/review',
    path: '/docs/$documentId/review',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/docs': typeof AuthDocsRoute
  '/docs/$documentId/review': typeof AuthDocsDocumentIdReviewRoute
  '/docs/$documentId/success': typeof AuthDocsDocumentIdSuccessRoute
  '/docs/$documentId/{-$step}': typeof AuthDocsDocumentIdChar123StepChar125Route
  '/docs/$documentId/': typeof AuthDocsDocumentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/docs': typeof AuthDocsRoute
  '/docs/$documentId/review': typeof AuthDocsDocumentIdReviewRoute
  '/docs/$documentId/success': typeof AuthDocsDocumentIdSuccessRoute
  '/docs/$documentId/{-$step}': typeof AuthDocsDocumentIdChar123StepChar125Route
  '/docs/$documentId': typeof AuthDocsDocumentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/docs': typeof AuthDocsRoute
  '/_auth/docs_/$documentId/review': typeof AuthDocsDocumentIdReviewRoute
  '/_auth/docs_/$documentId/success': typeof AuthDocsDocumentIdSuccessRoute
  '/_auth/docs_/$documentId/{-$step}': typeof AuthDocsDocumentIdChar123StepChar125Route
  '/_auth/docs_/$documentId/': typeof AuthDocsDocumentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/docs'
    | '/docs/$documentId/review'
    | '/docs/$documentId/success'
    | '/docs/$documentId/{-$step}'
    | '/docs/$documentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/docs'
    | '/docs/$documentId/review'
    | '/docs/$documentId/success'
    | '/docs/$documentId/{-$step}'
    | '/docs/$documentId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_auth/docs'
    | '/_auth/docs_/$documentId/review'
    | '/_auth/docs_/$documentId/success'
    | '/_auth/docs_/$documentId/{-$step}'
    | '/_auth/docs_/$documentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/docs': {
      id: '/_auth/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof AuthDocsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs_/$documentId/': {
      id: '/_auth/docs_/$documentId/'
      path: '/docs/$documentId'
      fullPath: '/docs/$documentId/'
      preLoaderRoute: typeof AuthDocsDocumentIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs_/$documentId/{-$step}': {
      id: '/_auth/docs_/$documentId/{-$step}'
      path: '/docs/$documentId/{-$step}'
      fullPath: '/docs/$documentId/{-$step}'
      preLoaderRoute: typeof AuthDocsDocumentIdChar123StepChar125RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs_/$documentId/success': {
      id: '/_auth/docs_/$documentId/success'
      path: '/docs/$documentId/success'
      fullPath: '/docs/$documentId/success'
      preLoaderRoute: typeof AuthDocsDocumentIdSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/docs_/$documentId/review': {
      id: '/_auth/docs_/$documentId/review'
      path: '/docs/$documentId/review'
      fullPath: '/docs/$documentId/review'
      preLoaderRoute: typeof AuthDocsDocumentIdReviewRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthDocsRoute: typeof AuthDocsRoute
  AuthDocsDocumentIdReviewRoute: typeof AuthDocsDocumentIdReviewRoute
  AuthDocsDocumentIdSuccessRoute: typeof AuthDocsDocumentIdSuccessRoute
  AuthDocsDocumentIdChar123StepChar125Route: typeof AuthDocsDocumentIdChar123StepChar125Route
  AuthDocsDocumentIdIndexRoute: typeof AuthDocsDocumentIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDocsRoute: AuthDocsRoute,
  AuthDocsDocumentIdReviewRoute: AuthDocsDocumentIdReviewRoute,
  AuthDocsDocumentIdSuccessRoute: AuthDocsDocumentIdSuccessRoute,
  AuthDocsDocumentIdChar123StepChar125Route:
    AuthDocsDocumentIdChar123StepChar125Route,
  AuthDocsDocumentIdIndexRoute: AuthDocsDocumentIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
